import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useIsNativeWebView from '../../../../services/native-bridge/hooks/useIsWebView';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sidebar: PropTypes.bool,
};

const Main = memo(({ children, className, sidebar }) => {
  const isNativeWebView = useIsNativeWebView();
  const classes = classNames({
    'pro-wrapper-main': true,
    'pro-wrapper-with-sidebar': sidebar,
    'is-web-view': isNativeWebView,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="pro-wrapper-main-wrap">{children}</div>
    </div>
  );
});

Main.propTypes = propTypes;
Main.displayName = 'Main';

export default Main;
